"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_MARKETING_SIGNUP = void 0;
const client_1 = require("@apollo/client");
exports.EMAIL_MARKETING_SIGNUP = (0, client_1.gql) `
  mutation Signup($email: String!, $source: String!, $subscriptionTypes: [String!]) {
    signup(input: { email: $email, source: $source, subscriptionTypes: $subscriptionTypes }) {
      isSent
    }
  }
`;
//# sourceMappingURL=emailmarketing.js.map